import React, {Component} from 'react';
import { Modal } from 'react-bootstrap';
import { translate } from 'react-i18next';
import { Table } from 'react-bootstrap';
import swal from 'sweetalert';
import FlatButton from 'material-ui/FlatButton';

var Config = require('../../../config');

class ModalSections extends Component{
	constructor(props){
		super(props);

		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.save = this.save.bind(this);

		this.state = {
			show: false,
			donation_id:"", 
			sections:[],
			check_all:false,
			type:""
		}
	}

	componentDidMount(){
		this.props.onRef(this);
	}

	componentWillUnmount(){
		this.props.onRef(null);
	}

	handleShow(don_1d, sections, type, petition=""){
		sections.map((s)=>{
			s.check = false;
		});
		
		this.setState({sections:sections, donation_id:don_1d, type:type, petition: petition});
		setTimeout(()=>{
			this.props.waiting.handleClose();
			this.setState({show:true});
		}, 1000);
		
	}

	handleClose(){
		this.setState({show:false, sections:[], donation_id:"", type:""});
	}

	handleChange(e){
		var sections = this.state.sections;
		var num = 0, sect = sections.length;

		if(e.target.id === 'check_all'){
			sections.map((s)=>{
				s.check = e.target.checked ? true : false
			})

			this.setState({check_all:e.target.checked ? true : false, sections:sections});
		}else{
			sections.map((s)=>{
				if(s.lab_section_id === parseInt(e.target.id)){
					s.check = e.target.checked ? true : false
				}

				
				if(s.check){num++;}
				
			})

			if(num === sect){
				this.setState({check_all:true, sections:sections});
			}else{
				this.setState({check_all:false, sections:sections});
			}
		}			

	}

	save(){
		var ids = [];
		this.state.sections.map((sect)=>{
			if(sect.check){
				ids.push(sect.lab_section_id);
			}
		})
	
		this.handleClose();
		if(this.state.type === 'single'){
			if(this.state.petition !== ""){
				this.props.validate(this.state.donation_id, ids, this.state.petition);
			}else{
				this.props.validate(this.state.donation_id, ids);
			}
			
		}else if(this.state.type === 'remove_lab'){
			this.props.removeValidation(ids);

		}else if(this.state.type === 'jefatura'){
			
			this.props.headship(ids);
		}else if(this.state.type === 'valid_lab'){
			this.props.openValidation(null, ids);
		}else{
			this.props.cascade(ids);
		}
	}

	render(){
		const { t } = this.props;

		return (
			<Modal show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>{this.state.type === 'remove_lab' ? 'Secciones a retirar validación' : 'Secciones a validar'}</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row">
		        		<div className="col-xs-12">
		        			<Table>
		        				<thead>
		        					<tr>
		        						<th>
		        							<input type="checkbox" id="check_all" onChange={this.handleChange} checked={this.state.check_all}/>
		        						</th>
		        						<th>TODOS</th>
		        					</tr>
		        				</thead>
		        				<tbody>
		        					{this.state.sections.map((sect, i)=>(
		        						<tr key={i}>
		        							<td>
		        								<input type="checkbox" id={sect.lab_section_id} onChange={this.handleChange} 
		        									checked={sect.check} />
		        							</td>
		        							<td>{sect.lab_section_name}</td>
		        						</tr>
		        					))}
		        				</tbody>
		        			</Table>
		        		</div>
		        	</div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={this.state.type === 'remove_lab' ? 'Ejecutar' : "Validar"}  onClick={this.save}/>
		        	<FlatButton primary={true} label={t('content.generics.buttons.reset')}  onClick={this.handleClose}/>
		        </Modal.Footer>
	      	</Modal>
	    )
	}
}

export default translate('translations')(ModalSections);